import React, { Component } from 'react'

class AboutUs extends Component {
  render = () => {
    return (
      <div>
        <div className="page-banner bg-page-banner vh-center">
          <div className="banner-content">
            <h2>About Us</h2>
          </div>
        </div>

        <div className="container">
          <div className="page-section">
            <h2 className="c-padd">About Us</h2>
            <p className="c-padd">
              EIDIM stands for "Everything Is Done In the Maker." The firm was established in September 1999, pursuing the motto "Spirituality & Competency Combined."
              The company was founded by Andrew W. Bang with Rex S. Kim, and David J. Kim. Their knowledge and expertise in the Audio-Visual industry enabled them to conceptualize EIDIM Group Inc., through which their plethora of knowledge could be offered to others in need. EIDIM Specializes in all aspects of the audiovisual world, such as consultation, design, installation, and more
          </p>
          </div>

          <div>
            <h2 className="c-padd">Vision</h2>
            <p className="c-padd">
              EIDIM’s Vision is to become a leader in the audiovisual industry based on the Christian culture, as well as becoming the supporter of our community in leading our clients to a modern environment.
            </p>
          </div>

          <div className="page-section">
            <h2 className="c-padd">Mission</h2>
            <p className="c-padd">
              EIDIM's Mission is to provide end-to-end quality installations, as well as complete customer satisfaction through our services. EIDIM provides follow-up services that ensure the systems we source and install work perfectly.  Not only does the client receive professional and quality services, but EIDIM also ensures that the project designs/details and installations undergo through scrutiny and attention to detail. EIDIM has and will continue to serve clients, not only by meeting challenging and high expectations, but rather surpassing all of them.
            </p>
          </div>

          <div style={{ paddingBottom: '2rem' }}>
            <h2 className="c-padd">Goal</h2>
            <p className="c-padd">
              EIDIM’s goal is to see through quality installation as well as complete customer satisfaction in the church that we are to serve. To provide follow-up services that will ensure the installed systems to be working perfectly. Not only will our client receive professional and quality service, but EIDIM will perform the best project designs/details and installation will undergo through scrutinous attention.
            </p>
          </div>

        </div>
      </div>
    )
  }
}

export default AboutUs